export default __webpack_public_path__ + "static/enterprise-platform-testing-3f43c77d087345b5a0bc6aa6bbb9c018.jpg";